import { useCallback, useEffect, useState } from "react";

const useCopyText = () => {
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false);
      }, 5000);
    }
  }, [isCopied]);

  const copyToClipboard = useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
    } catch (err) {
      console.error("Failed to copy: ", err);
      // Fallback: show text in alert for manual copy
      alert(`Copy failed. Please manually copy: ${text}`);
    }
  }, []);

  return { copyToClipboard, isCopied };
};

export default useCopyText;
